module.exports = __webpack_public_path__ + "img/32.822de964.png";